
































import { Component, Mixins, Emit, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { StringFilter, StringFilterParameter, RegExpFilterParameter } from "../../../../base/components/system/filters";
import { EditableFormatSummaryFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class EditableFormatSummaryMasterCodeFilter extends Mixins(ModelEditableMixin) {
  editingMasterCodeFirst: StringFilterParameter = new StringFilterParameter();
  editingMasterCodeSecond: StringFilterParameter = new StringFilterParameter();
  editingMasterCodeThird: StringFilterParameter = new StringFilterParameter();
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryFilterParameter) => void) => void;

  $refs!: {
    masterCodeSecond: HTMLInputElement,
    masterCodeThird: HTMLInputElement,
  };

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: EditableFormatSummaryFilterParameter, oldValue: EditableFormatSummaryFilterParameter) {
    if (newValue && oldValue && newValue.masterCode.regExp !== oldValue.masterCode.regExp && newValue.masterCode.regExp === null) {
      // 基本的に上位からパラメータを更新されることはないが、クリアされたときは空にする必要がある
      this.editingMasterCodeFirst = new StringFilterParameter();
      this.editingMasterCodeSecond = new StringFilterParameter();
      this.editingMasterCodeThird = new StringFilterParameter();
    }
    this.updateMasterCodeText();
  }

  get masterCode(): RegExpFilterParameter {
    return this.readPropertyOrDefault(s => s.masterCode, null);
  }

  set masterCode(source: RegExpFilterParameter) {
    this.writeProperty(s => s.masterCode = source);
  }

  get masterCodeFirst(): StringFilterParameter {
    return this.editingMasterCodeFirst;
  }

  set masterCodeFirst(source: StringFilterParameter) {
    this.editingMasterCodeFirst = source;
    this.updateMasterCode();
  }

  get masterCodeSecond(): StringFilterParameter {
    return this.editingMasterCodeSecond;
  }

  set masterCodeSecond(source: StringFilterParameter) {
    this.editingMasterCodeSecond = source;
    this.updateMasterCode();
  }

  get masterCodeThird(): StringFilterParameter {
    return this.editingMasterCodeThird;
  }

  set masterCodeThird(source: StringFilterParameter) {
    this.editingMasterCodeThird = source;
    this.updateMasterCode();
  }

  private updateMasterCode(): void {
    const pattern = "("
      + this.masterCodeFirst.keyword
      + ")-?("
      + this.masterCodeSecond.keyword
      + ")-?("
      + this.masterCodeThird.keyword
      + ")";
    this.masterCode = new RegExpFilterParameter(new RegExp(pattern, "i"));
  }

  async onEnterTextMasterCodeFirst(): Promise<void> {
    await this.$nextTick();
    this.$refs.masterCodeSecond.focus();
  }

  async onEnterTextMasterCodeSecond(): Promise<void> {
    await this.$nextTick();
    this.$refs.masterCodeThird.focus();
  }

  @Emit("updateText")
  updateMasterCodeText(): string {
    return this.masterCodeFirst.keyword !== "" || this.masterCodeSecond.keyword !== "" || this.masterCodeThird.keyword !== ""
      ? this.masterCodeFirst.keyword + "-" + this.masterCodeSecond.keyword + "-" + this.masterCodeThird.keyword
      : "";
  }
}
